export const getDateISO = date => (
  (date instanceof Date) ?
    date.toISOString().substring(0, 10) :
    date
);

export const getDateTimeISO = date => (
  (date instanceof Date) ?
    date.toISOString().replace('T', ' ').substring(0, 19) :
    date
);
